module.exports = __webpack_public_path__ + "static/media/everything-you-need.3e30f0ea.jpg";